import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingBulletedList: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0H0v4h4zm12 0H6v4h10zM0 6h4v4H0zm16 0H6v4h10zM0 12h4v4H0zm16 0H6v4h10z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingBulletedList
